import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Navbar as BootstrapNavbar,
  Nav,
  Container,
  NavDropdown,
  Badge,
} from "react-bootstrap";
// import { authAPI } from "../services/api";

const CustomNavbar = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  const isActive = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="shadow">
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" className="fw-bold">
          <img
            src="/NewLogo.png" // Change this to your actual image path
            alt="ISLPOS Logo"
            height="30" // Adjust height as needed
            className="d-inline-block align-middle me-2"
          />
          ISLPOS
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />

        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link as={Link} to="/" className={isActive("/")}>
              🏠 Dashboard
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/customers"
              className={isActive("/customers")}
            >
              👥 Customers
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/transactions"
              className={isActive("/transactions")}
            >
              💰 Transactions
            </Nav.Link> */}
            {user && user.role === "admin" && (
              <Nav.Link as={Link} to="/app" className={isActive("/app")}>
                🏠 Dashboard
              </Nav.Link>
            )}
            {/* {user.role === "admin" && (
              <Nav.Link
                as={Link}
                to="/app/customers"
                className={isActive("/app/customers")}
              >
                👥 Customers
              </Nav.Link>
            )}
            {user.role === "admin" && (
              <Nav.Link
                as={Link}
                to="/app/transactions"
                className={isActive("/app/transactions")}
              >
                💰 Transactions
              </Nav.Link>
            )} */}

            <Nav.Link
              as={Link}
              to="/dashboard"
              className={isActive("/dashboard")}
            >
              📋 My Requests
            </Nav.Link>

            {user && user.role === "admin" && (
              <Nav.Link
                as={Link}
                to="/admin/installations"
                className={isActive("/admin/installations")}
              >
                🛠️ Admin Panel
              </Nav.Link>
            )}
            {/* {user.role === "admin" && (
              <NavDropdown title="📊 Reports" id="reports-dropdown">
                <NavDropdown.Item as={Link} to="/reports/revenue">
                  Revenue Report
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/reports/overdue">
                  Overdue Payments
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/reports/subscriptions">
                  Subscription Analytics
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/reports/export">
                  Export Data
                </NavDropdown.Item>
              </NavDropdown>
            )} */}
          </Nav>

          <Nav className="align-items-center">
            <Badge bg="info" className="me-3">
              Role: {user && user.role}
            </Badge>

            <NavDropdown
              title={<span>👤 {user && user.username}</span>}
              align="end"
            >
              {/* <NavDropdown.Item as={Link} to="/profile">
                👤 My Profile
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/settings">
                ⚙️ Settings
              </NavDropdown.Item> */}
              {/* <NavDropdown.Divider /> */}
              <NavDropdown.Item onClick={handleLogout}>
                🚪 Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default CustomNavbar;
